import { useMemo } from "react";

import { useGetOrgaInfo } from "@/hooks/api/organisation/useGetOrgaInfo";

const freeTierLimit = 25;
const useTierLimit = () => {
  const { data: organisationData } = useGetOrgaInfo();
  const tierLimit = useMemo(() => organisationData?.plan.limit || freeTierLimit, [organisationData?.plan.limit]);

  const isFreeTier = useMemo(() => tierLimit <= freeTierLimit, [tierLimit]);
  return { tierLimit, isFreeTier };
};

export default useTierLimit;
